import styled from 'styled-components';

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  min-height: 150px;
  cursor: text;
  border: 1px solid rgb(206, 212, 218);

  & > p > img {
    max-width: 100%;
    height: auto;
  }
`;
